import { ValidationResult } from '../interfaces';
import { FormFieldValue } from '..';
import { checkEmailValidLoqate } from '../../services';

export const validateEmail = async (
  value: FormFieldValue
): Promise<ValidationResult> => {
  if (typeof value === 'string') {
    if (!(value as string).length) return { valid: true, errors: [] };

    const emailRegex =
      /* eslint-disable-next-line no-useless-escape */
      // eslint-disable-next-line no-control-regex
      /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
    const valid = value.match(emailRegex) ? true : false;

    if (valid) {
      const loqateResponse = await checkEmailValidLoqate(
        encodeURIComponent(value)
      );

      return loqateResponse.response?.ResponseCode !== 'Valid' &&
        loqateResponse.response?.ResponseCode !== 'Valid_CatchAll'
        ? { valid: false, errors: ['Undeliverable email address'] }
        : { valid: true, errors: [] };
    }
  }

  return { valid: false, errors: ['Invalid email format'] };
};
